import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/navbar/Navbar";
import "./dashboard.css";
import { useState, useEffect } from "react";
const AdminLayout = ({ children }) => {
  const [showSideBar, setShowSideBar] = useState(true);

  const handleShowSideBar = () => {
    setShowSideBar(!showSideBar)
  }
  useEffect(() => {
    if(window.innerWidth < 890) {
      setShowSideBar(true)
      // console.log(window.innerWidth)
    } else {
      setShowSideBar(true)
      // console.log(window.innerWidth)
    }
  }, [])
  return (
    <div className="dashboard">
      <Navbar handleSideBar={handleShowSideBar} showSideBar={showSideBar}/>
      {
        showSideBar && <Sidebar />
      }
      
      <div className="md:pl-[14%] lg:mt-[40px] pl-0 w-[100vw]  overflow-auto">{children}</div>
    </div>
  );
};

export default AdminLayout;
